export default {
  tooltip_title: 'Klik om te kopiëren',
  success: 'Gekopieerd!',
};
